import React from 'react';
import { ThemeProvider } from '@mui/material';
import { partnerTheme } from './partnerTheme';

/**
 * Provider для изолированной темы Профиля Партнера
 * 
 * Оборачивает children в отдельную MUI тему, независимую от глобальной.
 * Используется на страницах профиля партнера для консистентного вида.
 * 
 * @example
 * <PartnerThemeProvider>
 *   <PartnerProfileContent partnerId={1} />
 * </PartnerThemeProvider>
 */
export interface PartnerThemeProviderProps {
  children: React.ReactNode;
}

export const PartnerThemeProvider: React.FC<PartnerThemeProviderProps> = ({ 
  children 
}) => {
  return (
    <ThemeProvider theme={partnerTheme}>
      {children}
    </ThemeProvider>
  );
};
